import { useGoogleAnalytics } from '@/shared/composables'
import { useCommonStore } from '@/shared/store'

export const useAbTest = () => {
  const gaService = useGoogleAnalytics()
  const commonStore = useCommonStore()

  const getAbTest = async (key: string) => {
    const value = await commonStore.getAbTest(key)
    if (value) {
      gaService.sendAbTest(key, value)
    }
  }

  return { getAbTest }
}
